module.exports = __webpack_public_path__ + "img/lorient-logo-icon.c17b8d39.png";